export default __webpack_public_path__ + "static/media/hango-screenshot-01.0073b639.png";